import React from 'react';
import PropTypes from 'prop-types';
import {
    Row,
    Col,
    Divider,
    Button,
} from 'antd';
import BookingTableRowItemValue from './BookingTableRowItemValue';
import { createDashboardRowData } from '../../utils';


const propTypes = {
    record: PropTypes.object.isRequired,
};

const BookingTableRowCustomer = ({ record, handleCancelClick }) => {
    if (!record) return null;

    const values = createDashboardRowData(record);

    return (
        <Row>
            <Row gutter={40}>
                <Col span={8}>
                    <BookingTableRowItemValue label="Contact Number" value={values.contact_number} />
                    <BookingTableRowItemValue label="Email Address" value={values.email_address} />
                    <BookingTableRowItemValue label="Addons" value={values.selected_addons} />
                    <BookingTableRowItemValue label="Total Charge" value={values.total_charge} />
                </Col>
                <Col span={8}>
                    <BookingTableRowItemValue label="Property Type" value={values.property_type} />
                    <BookingTableRowItemValue label="Has Parking" value={values.has_parking_available} />
                    <BookingTableRowItemValue label="Has Access to Back of Property" value={values.has_access_to_back_of_property} />
                    {
                        values.additional_comments &&
                        <BookingTableRowItemValue label="Additional Comments" value={values.additional_comments} />
                    }
                </Col>
                <Col span={8}>
                    {
                        record.booking_amended &&
                        <BookingTableRowItemValue label="Previous Booking Date" value={values.previous_date_time} />
                    }
                    {
                        record.booking_cancelled &&
                        <>
                            <BookingTableRowItemValue label="Cancelled On" value={values.cancelled_at} />
                            <BookingTableRowItemValue label="Booking Refunded" value={values.eligible_for_refund} />
                        </>
                    }
                </Col>
            </Row>
            <Divider />
            {
                !record.booking_cancelled &&
                <Row gutter={40}>
                    <Col span={24}>
                        <Button onClick={handleCancelClick(record)}>
                            Cancel booking
                        </Button>
                    </Col>
                </Row>
            }
        </Row>
    );
};

BookingTableRowCustomer.propTypes = propTypes;

export default BookingTableRowCustomer;
